import { COOKIE_EXPIRATION_YEARS } from '~shared/modules/price-type-toggler/constants/cookie-expiration.constant';

export function createCookieExpiration() {
  const date = new Date();
  const year = date.getFullYear() + COOKIE_EXPIRATION_YEARS;
  date.setFullYear(year);
  return date;
}
